import FieldUser, {ADD_USER} from "../../../../generic/user/user"
import FieldConfig from "../../../../proto/field-config"
import {ProjectAccess} from "../../../../../gd/const/project"
import {PopoverMenuItemType} from "../../../../../gd-components/popover-menu/popover-menu/const"
import {ProjectItem} from "../../../../../model2/project-item/project-item"
import ProjectUserSession from "../../../../../model2/project-user/project-user-session"
import FieldTaskAssignedToUser_ConditionForm from "./render/condition"
import FieldTaskAssignedToUser_QuickFilterView from "./render/quick-filter-view"
import Task from "../../../../../model2/task/task"
import FieldTaskAssignedToUser_GoalListEditable from "./render/goal-list-editable"
import FieldTaskAssignedToUser_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldTaskAssignedToUser_GoalListView from "./render/goal-list-view"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import {FieldDropdown_filterValuesFiller} from "../../../../conditions/dropdown"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"
import {FieldGroupAllPossibleValues_Params} from "../../../../proto/types"
import {CompanyRole} from "../../../../../gd/const/company-role";
import FieldTaskAssignedToUser_AutomationActionForm from "./render/automation/automation-action";

export default class FieldTaskAssignedToUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel                          = "Task Assigned to User"
        this.icon                               = 'i5-user-assigned'

        // this.noValueOption = true;
        // this.noValueOptionLabel = 'Not assigned';

        // this.components = _.assign({}, this.components, {
        //     PopoverMenuMore : null,
        // })

        this.placeholder                            = "Not assigned"

        this.isGroupByAllOptionsAvailable           = true

        this.components.PopoverMenuMore             = null
        this.components.PickerValueNotEmpty         = FieldTaskAssignedToUser_PickerValueNotEmpty

        this.classes.PopoverMenuScrollContainer     = 'min-w-250 max-h-300'

        this.renderComponents.quickFilterView       = FieldTaskAssignedToUser_QuickFilterView
        this.renderComponents.goalListEditable      = FieldTaskAssignedToUser_GoalListEditable
        this.renderComponents.goalListView          = FieldTaskAssignedToUser_GoalListView

        this.renderComponents.conditionForm         = FieldTaskAssignedToUser_ConditionForm
        this.renderComponents.filterForm            = FieldTaskAssignedToUser_ConditionForm

        this.renderComponents.automationActionForm  = FieldTaskAssignedToUser_AutomationActionForm

        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange

        this.filterValuesFiller                     = FieldDropdown_filterValuesFiller




    }

    canEdit(model: Task): boolean {
        return model.acl.canChangeAssignedTo
    }

    access(model:any) {
        return gd.const.systemStatus.isOpen(model.systemStatus) && gd.ac.check.project.fullAccess(model.projectId) ? 'write' : 'read';
    }

    getOptionsForEdit(model:any) {

        const projectId = model.projectId

        if (!projectId) {
            console.log("FieldTaskActionRequired #ERROR-FIELD-TASK-ACTION-REQUIRED-USER-45 no model passed")
            return []
        }

        const isNonClient = (userId: ID) => {
            const companyUser = gd.session.companyUsers.getByUserId(userId)
            return !!companyUser && companyUser.companyRole !== CompanyRole.CLIENT
        }

        // we need to remove clients and read only users from this list
        const isEligible = (projectUser?: ProjectUserSession) => {
            // make sure company user exists
            const companyUser = projectUser && gd.session.companyUsers.getByUserId(projectUser.user?.id)
            if (!companyUser) {
                return false
            }

            // make sure it's not client
            if (companyUser.companyRole === gd.const.companyRole.CLIENT) {
                return false
            }

            // make sure they have edit access
            if ([
                ProjectAccess.READ_ONLY,
                ProjectAccess.CLIENT
            ].includes(projectUser.access)) {
                return false
            }

            return true
        }

        const toOption = (pu: ProjectUserSession): Option => ({
            value: pu.user.id,
            label: pu.user.name
        })

        const options: Option[] = []

        if (!model.projects || model.projects.length === 0) {
            // Fallback: use projectId only
            const projectUsers = gd.session.projectUsers.filterByProject(projectId, gd.const.project.access.LIMITED)
            _.each(projectUsers.models, (projectUser: ProjectUserSession) => {
                if (isEligible(projectUser)) {
                    options.push(toOption(projectUser))
                }
            })
        } else {
            // Task users first
            const taskUserIds: Set<ID> = new Set()
            _.each(model.users, (taskUser: any) => {
                if (taskUser.userId && isNonClient(taskUser.userId)) {
                    const user = gd.session.users.get(taskUser.userId)
                    if (user) {
                        taskUserIds.add(taskUser.userId)
                        options.push({
                            value   : taskUser.userId,
                            label   : user.name
                        })
                    }
                }
            })

            // All remaining project users (no duplicates)
            const projectIds: ID[] = _.map(model.projects, (projectItem: ProjectItem) => {
                return projectItem.projectId
            })
            const projectUsers = gd.session.projectUsers.filterByProjects(projectIds, gd.const.project.access.LIMITED)

            const allProjectOptions: Option[] = []
            _.each(projectUsers.models, (pu: ProjectUserSession) => {
                if (isEligible(pu) && !taskUserIds.has(pu.user.id)) {
                    allProjectOptions.push(toOption(pu))
                }
            })

            if (allProjectOptions.length > 0) {
                if (options.length > 0) {
                    options.push({
                        type: PopoverMenuItemType.SEPARATOR
                    })
                }
                options.push(...allProjectOptions)
            }
        }

        // there can be no acl in model (for example RequestForm model)
        if (model.acl?.canAddUser) {
            options.push({
                value   : ADD_USER,
                label   : 'Add User',
                icon    : 'i5-plus'
            })
        }

        return options
    }

    tableCellOnValueChange = (item: ItemModelV2, value: any, manager: TasksViewManager) => {


        // Special case whn add a user
        if (value === ADD_USER) {
            item.task.addUserAsAssignee()
            return
        }


        item.task.assignedToUserId = value
        item.task.save()

        item.updateLastUpdateTime() // otherwise it wont re-render

        // need it becuase of workday duration depends on Assignee
        FieldProto_updateView(manager as TasksViewManager, this)

    }

    /** GROUP BY **/
    groupAllPossibleValues(params: FieldGroupAllPossibleValues_Params): any[] {
        const allUserIdsSet: Set<ID | null> = new Set<ID | null>()
        allUserIdsSet.add(null)

        if (params.project) {
            _.map(gd.session.projectUsers.filterByProject(params.project.id, gd.const.project.access.LIMITED).models, projectUser => {
                if (projectUser?.user?.id) {
                    allUserIdsSet.add(projectUser.user.id)
                }
            })

            _.map(params.items, (itemModel: ItemModelV2) => {
                if (itemModel.isTask && itemModel.task.assignedToUserId) {
                    allUserIdsSet.add(itemModel.task.assignedToUserId)
                }
            })
        } else {
            const projectIds: Set<ID> = new Set<ID>()

            _.map(params.items, (itemModel: ItemModelV2) => {
                if (itemModel.isTask) {
                    if (itemModel.task.assignedToUserId) {
                        allUserIdsSet.add(itemModel.task.assignedToUserId)
                    }

                    projectIds.add(itemModel.task.projectId)
                }
            })

            _.map(gd.session.projectUsers.filterByProjects([...projectIds], gd.const.project.access.LIMITED).models, projectUser => {

                if (projectUser.isTeam) return

                if (projectUser?.user?.id) {
                    allUserIdsSet.add(projectUser.user.id)
                } else {
                    console.error("#kldjf0934 how come - no project user?")
                }


            })
        }

        return _.orderBy([...allUserIdsSet],
            [
                // null/undefined values are sorted first/last depending on direction
                (value: any) => {
                    return _.isNil(value) ? 0 : 1
                },
                // actual group value using field sort function
                (value: any) => {
                    return this.groupSortValue(value, params.groupBy)
                },
            ],
            [
                params.groupBy.sortDirection,
                params.groupBy.sortDirection
            ],
        )
    }

}
